import React, { useEffect } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SITE } from "../data/content";

const CONTENT = {
  privacy: {
    eyebrow: "Privacy",
    title: "Privacy Policy",
    intro: "We treat the information you share with the seriousness it deserves.",
    body: [
      { h: "What we collect", p: "We collect only the information you provide through our intake, referral, and contact forms — such as your name, contact details, and a description of your situation." },
      { h: "How we use it", p: "Your information is used solely to coordinate support, respond to your inquiry, or process a referral. We do not sell, rent, or trade personal information to third parties." },
      { h: "Who can see it", p: "Access is limited to Iron Shield staff and authorized partners directly involved in coordinating care. Sensitive intake details are handled confidentially." },
      { h: "Your choices", p: "You may request that we correct or delete your information at any time by emailing us." },
    ],
  },
  terms: {
    eyebrow: "Terms",
    title: "Terms of Use",
    intro: "The basics of using this website.",
    body: [
      { h: "Informational purpose", p: "This website provides information about Iron Shield's programs and services. It is not a substitute for emergency, medical, or legal services." },
      { h: "No emergency service", p: "Iron Shield is not an emergency provider. If you are in immediate danger, call 911, or contact the Veterans Crisis Line at 988, then press 1." },
      { h: "Accuracy", p: "We work to keep information current but make no guarantee that all content is complete or error-free. Programs and eligibility may change." },
    ],
  },
  accessibility: {
    eyebrow: "Accessibility",
    title: "Accessibility Statement",
    intro: "This site is built to be usable by everyone.",
    body: [
      { h: "Our commitment", p: "We aim to meet WCAG 2.1 AA standards, including sufficient color contrast, keyboard navigation, semantic structure, and support for reduced-motion preferences." },
      { h: "Ongoing work", p: "Accessibility is an ongoing effort. We continue to test and improve the experience across devices and assistive technologies." },
      { h: "Feedback", p: "If you encounter a barrier using this site, please let us know so we can fix it." },
    ],
  },
};

const LegalPage = ({ kind }) => {
  const data = CONTENT[kind];
  useEffect(() => { document.title = `${data.title} | Iron Shield Veterans Reset Center`; }, [data.title]);
  return (
    <>
      <PageHero eyebrow={data.eyebrow} title={data.title} intro={data.intro} />
      <section className="py-20 md:py-28 bg-offwhite">
        <div className="container-x max-w-3xl">
          <div className="space-y-12">
            {data.body.map((sec, i) => (
              <Reveal key={sec.h} delay={i * 0.05}>
                <h2 className="font-heading text-2xl font-bold text-navy">{sec.h}</h2>
                <p className="mt-3 text-charcoal/80 md:text-lg leading-relaxed">{sec.p}</p>
              </Reveal>
            ))}
            <Reveal>
              <div className="border-t border-softgray pt-8">
                <p className="text-charcoal/80">Questions? Email <a href={`mailto:${SITE.email}`} className="font-semibold text-navy hover:text-gold-deep transition-colors">{SITE.email}</a>.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default LegalPage;
